import { Button, colors, ModalActions, ModalHeader, Stack } from '@ui-components/neo.tax';
import { SyntheticEvent } from 'react';

import { CsvLogo, CsvUploadInstructions, useCsvFileUrl } from '@neo.tax/shared';

import { EXAMPLE_DATA_STRINGIFIED, HEADERS_STRINGIFIED } from './rd-project-bulk-upload-instruction-modal.constants';
import { StyledModal } from './rd-project-bulk-upload-instruction-modal.styled';

type RdProjectBulkUploadInstructionModalProps = {
  close: () => void;
  isOpen: boolean;
  loading: boolean;
  submit: () => void;
};

export const RdProjectBulkUploadInstructionModal = ({
  close,
  isOpen,
  loading,
  submit,
}: RdProjectBulkUploadInstructionModalProps): React.ReactElement => {
  const templateCsvUrl = useCsvFileUrl(HEADERS_STRINGIFIED);
  const exampleCsvUrl = useCsvFileUrl(EXAMPLE_DATA_STRINGIFIED);

  const onSubmit = (e: SyntheticEvent): void => {
    e.preventDefault();
    submit();
  };

  return (
    <StyledModal isOpen={isOpen}>
      <Stack as="form" direction="column" onSubmit={onSubmit}>
        <Stack direction="column" gap={4}>
          <ModalHeader icon={<CsvLogo />} iconBgColor={colors.white} title="Upload R&D Projects CSV" />
          <Stack direction="column" gap={2}>
            <CsvUploadInstructions
              title="Add one row per R&D project you want to create."
              templateCsvUrl={templateCsvUrl}
              templateCsvName="rd-projects-csv-upload-template.csv"
              exampleCsvUrl={exampleCsvUrl}
              exampleCsvName="rd-projects-csv-upload-example.csv"
            />
          </Stack>
        </Stack>

        <ModalActions hasTopBorder={false}>
          <Button variant="white" rounded="regular" size="base" onClick={close}>
            Cancel
          </Button>
          <Button disabled={loading} variant="primary" rounded="regular" size="base" type="submit">
            {loading ? 'Loading...' : 'Upload'}
          </Button>
        </ModalActions>
      </Stack>
    </StyledModal>
  );
};
